import { create } from 'zustand';

/**
 * Ephemeral UI state shared between app chrome and immersive surfaces.
 *
 * `immersive` is set by pages that take over the full viewport (games, 3D
 * labs, music studio, etc.) so AppShell can hide BottomNav, strip the
 * bottom padding from <main>, and zero out --bottom-nav-h so any child
 * using --safe-game-h gets the entire dvh minus chrome.
 *
 * Callers MUST clear the flag on unmount (return () => setImmersive(false))
 * or the rest of the app inherits the no-nav state when the user navigates
 * out of an immersive surface.
 */
interface UIState {
  immersive: boolean;
  setImmersive: (value: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  immersive: false,
  setImmersive: (immersive) => set({ immersive }),
}));
